module.exports = __webpack_public_path__ + "static/img/paotui-tips.a49afed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paotui-tips.jpg
// module id = ZHjT
// module chunks = 1